




















































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import TextField from '@/componentsV2/molecules/Inputs/TextField.vue';
import FormHeader from '@/componentsV2/molecules/FormHeader/FormHeader.vue';
import Dropdown from '@/components/molecules/Dropdown/Dropdown.vue';
import ImageUpload from '@/componentsV2/molecules/Inputs/ImageUploadV2.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import SelectionBox from '@/componentsV2/molecules/Inputs/SelectionBox.vue';

import SpecialCoinIcon from '@/components/icons/SpecialCoin.vue';
import InfoIcon from '@/components/icons/Info.vue';

import flagKeys from '@/constants/flagKeys';
import {
  IOfferDiscountType,
  OfferDiscountDictionary,
  SpecialOfferTypeEnum,
  IOfferEdit
} from '@/models/offer';

interface IOption<T = string> {
  id: number;
  value: T;
  label: string;
}

@Component({
  components: {
    TextField,
    FormHeader,
    Dropdown,
    SpecialCoinIcon,
    ImageUpload,
    Typography,
    InfoIcon,
    SelectionBox
  }
})
export default class OfferDetails extends Vue {
  @Prop() errors!: string[];
  @Prop() offer?: IOfferEdit;
  @Prop() offerData?: IOfferEdit;
  @Prop() type!: SpecialOfferTypeEnum;
  @Prop() imageOptional!: boolean;
  @Prop() showOverview!: boolean;

  offerDiscountTypeOptions: IOption<IOfferDiscountType>[] = [
    {
      id: 0,
      label: OfferDiscountDictionary[IOfferDiscountType.PERCENTAGE],
      value: IOfferDiscountType.PERCENTAGE
    },
    {
      id: 1,
      label: this.businessCurrency,
      value: IOfferDiscountType.AMOUNT
    }
  ];

  data: any = {
    title: this.offer && this.offer.title ? this.offer.title : '',
    discountType:
      this.offer && this.offer.discount && this.offer.discount.typeName
        ? this.offer.discount.typeName
        : this.defaultDiscountType.value,
    discountAmount:
      this.offer && this.offer.discount && this.offer.discount.value
        ? this.offer.discount.value
        : '',
    ...(this.$mobileCheck() || !this.showOverview
      ? {
          imageId:
            this.offer && this.offer.image && this.offer.image.id
              ? this.offer.image.id
              : '',
          imageLink:
            this.offer && this.offer.image && this.offer.image.url
              ? this.offer.image.url
              : ''
        }
      : {}),
    originalPrice:
      this.offer && this.offer.discount && this.offer.discount.originalValue
        ? this.offer.discount.originalValue
        : '',
    avgDiscountValue:
      this.offerData && this.offerData.avgDiscountValue
        ? this.offerData.avgDiscountValue
        : '',
    savingsCannotBeDetermined:
      this.offer && this.offer.savingsCannotBeDetermined
        ? this.offer.savingsCannotBeDetermined
        : false
  };

  offerDiscountTypeInitialValue = this.defaultDiscountType.label;

  get tPrefix() {
    return 'offers.form';
  }

  get businessCurrency() {
    return (
      this.$store.getters['internationalization/getCountrySettings']
        .currencySymbol || '$'
    );
  }

  get isBirthday() {
    return this.type === SpecialOfferTypeEnum.BIRTHDAY;
  }

  get isTwoForOne() {
    return this.type === SpecialOfferTypeEnum.TWO_FOR_ONE;
  }

  get shouldShowDiscountAmount() {
    return this.type === SpecialOfferTypeEnum.PRODUCT_AND_SERVICE;
  }

  get titleHelpText() {
    return `${this.$t(`${this.tPrefix}.titleHelpText.prefix`)} ${this.$t(
      `${this.tPrefix}.titleHelpText.${this.type}`
    )}`;
  }

  get defaultDiscountType() {
    const value =
      this.offerData && (this.offerData as any).discountType
        ? (this.offerData as any).discountType
        : IOfferDiscountType.AMOUNT;

    return this.offerDiscountTypeOptions.find(
      method => method.value === value
    ) as IOption<IOfferDiscountType>;
  }

  get discountMask() {
    if (this.data.discountType === IOfferDiscountType.PERCENTAGE) {
      return 'percentage';
    }

    return 'currency';
  }

  get characterLimitationIsActivated() {
    return !this.flags.includes(flagKeys.disableCharacterLimitationOnOffer);
  }

  get flags() {
    return this.$store.getters['flags/getFlags'];
  }

  @Watch('data', { deep: true })
  changedData(data: any) {
    this.$emit('input', data);
  }

  onUploadImage(response: any) {
    this.data.imageId = response.id;
    this.data.imageLink = response.link;
    this.$emit('clearError', 'offer-image');
  }

  onDeleteImage() {
    this.data.imageId = '';
    this.data.imageLink = '';
    this.$emit('clearError', 'offer-image');
  }

  onOriginalPriceInput($event: any) {
    this.data.originalPrice = $event;
    this.$emit('clearError', 'offer-original-price');
    this.$emit('clearError', 'offer-original-price-empty');
  }

  onAvgDiscountValueInput($event: any) {
    this.data.avgDiscountValue = $event;
    this.$emit('clearError', 'offer-avg-discount-value');
  }

  onDiscountAmountInput() {
    this.$emit('clearError', 'offer-discount-amount');
    this.$emit('clearError', 'offer-discount-amount-empty');
  }

  handleDropdownInput(type: IOfferDiscountType) {
    (document.querySelector(
      '#offer-discount-amount'
    ) as HTMLInputElement).value = '';
    this.data.discountAmount = '';
  }
}
